<script setup>
import {defineProps, watch, defineEmits, onMounted, ref, nextTick} from 'vue'

const emit = defineEmits([ "value" ]);

const props = defineProps({
  name: String,
  type: String,
  required: Boolean,
  description: String,
  value: String
})

var v = ref(props.value)

</script>

<template>
  <div>
    <div class="param-container">
      <div class="param-header">
        <span class="me-2 param-name">{{ props.name }}</span>
        <span v-if="props.type" class="type-badge">{{ props.type }}</span>
        <span v-if="props.required" class="ms-2 required-badge">required</span>
      </div>
      <p class="param-description">{{ props.description }}</p>
      <input
        v-model="v"
        @input="$emit('value', v)"
        class="param-input"
        type="text"
        :placeholder="'Enter ' + props.name.toLowerCase()"
      />
    </div>
  </div>
</template>

<style scoped>
.param-container {
  padding: 1rem;
  border-radius: var(--radius-lg);
  background-color: var(--surface-sunken);
}

.param-header {
  display: flex;
  align-items: center;
  font-weight: normal;
  margin-bottom: 0.5rem;
}

.param-name {
  color: var(--text-primary);
  font-weight: 600;
  font-family: var(--font-heading);
  font-size: 0.95rem;
}

.type-badge {
  font-size: var(--fs-xs);
  font-weight: 500;
  color: var(--accent-text);
  background: var(--accent-soft-2);
  padding: 0.1rem 0.5rem;
  border-radius: var(--radius-xs);
}

.required-badge {
  font-size: var(--fs-xs);
  font-weight: 500;
  color: var(--color-error-text);
  background: var(--color-error-soft);
  padding: 0.1rem 0.5rem;
  border-radius: var(--radius-xs);
}

.param-description {
  color: var(--text-secondary);
  margin-bottom: 1rem;
  font-size: 0.9rem;
}

.param-input {
  width: 100%;
  padding: 0.75rem;
  border-radius: var(--radius-md);
  border: 1px solid var(--border-strong);
  background-color: var(--surface-inset);
  color: var(--text-heading);
  font-size: 0.9rem;
  font-family: var(--font-heading);
  transition: var(--transition);
}

.param-input:focus {
  outline: none;
  border-color: var(--accent-text);
  box-shadow: 0 0 0 3px var(--accent-soft-3);
}

.param-input::placeholder {
  color: var(--text-secondary);
}
</style>
